<script setup lang="ts">
import { tv } from 'tailwind-variants'

const heading3Variants = tv({
	base: 'text-1xl font-semibold tracking-tight',
})
</script>

<template>
	<h3 :class="heading3Variants()">
		<slot />
	</h3>
</template>
